/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_014: Question = {
  id: 'pres-014-zones-noyaux-zonage',
  oldId: '28',
  title: 'Intégration des zones noyaux ou des milieux naturels d’intérêt et du concept de corridor de connectivité dans le règlement de zonage et autres règlements d\'urbanismes et plan d\'urbanisme.',
  number: '2.14',
  description: ['Règlement de zonage et autres règlements d’urbanisme et plan d’urbanisme (PU).'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 3,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_014__v3: Question = {
  ...question_pres_014,
  title: 'Intégration des zones noyaux ou des milieux naturels d’intérêt et du concept de corridor de connectivité dans le règlement de zonage et autres règlements d\'urbanismes et plan d\'urbanisme',
  number: '2.12',
};

export const question_pres_014_v2: Question = question_pres_014;
export const question_pres_014_v3: Question = question_pres_014__v3;
